import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';

export const CreateRecurringTaskButton: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/recurring-tasks/create');
  };

  return (
    <Button
      variant="contained"
      startIcon={<Add />}
      onClick={handleClick}
      sx={{
        backgroundColor: '#162346',
        '&:hover': {
          backgroundColor: '#1a2a52'
        },
        fontWeight: 600
      }}
    >
      Create Recurring Task
    </Button>
  );
};

export default CreateRecurringTaskButton;
